import { WHATSAPP_ERRORS, CONTACT_ERRORS, AUTH_ERRORS, COMPANY_SETTINGS_ERRORS, COMPANY_ERRORS, AUDIT_ERRORS , TICKET_ERRORS, CAMPAIGN_ERRORS, SCHEDULE_ERRORS, ANNOUNCEMENT_ERRORS, MEDIA_ERRORS, MESSAGE_ERRORS} from "@markedesk/core-contracts";

const messages = {
  es: {
    translations: {
      callbacks: {
        title: "Callbacks",
        subtitle:
          "Avisamos a una dirección suya cada vez que ocurre un evento en la plataforma. El aviso se envía una vez — si la dirección está caída en ese momento, no se reenvía.",
        add: "Agregar destino",
        emptyTitle: "Ningún destino registrado",
        emptyText: "Registre una dirección para recibir avisos cuando algo ocurra aquí.",
        search: "Buscar por dirección, descripción o evento",
        event: "Evento",
        allEvents: "Todos los eventos",
        situation: "Situación",
        all: "Todas",
        receiving: "Recibiendo",
        paused: "Pausados",
        failing: "Con fallo en el último envío",
        clear: "Limpiar",
        noMatch: "Ningún destino coincide con el filtro.",
        orphanChip: "evento no disponible",
        orphanTooltip:
          "El plugin que anunciaba este evento ya no está instalado — este destino no recibe nada.",
        signedTooltip: "Enviamos la firma del contenido",
        activeTooltip: "Recibir avisos",
        pausedTooltip: "Pausado",
        testTooltip: "Enviar un aviso de prueba ahora",
        waitingFirst: "esperando el primer evento",
        received: "recibió",
        failed: "falló",
        answered: "Respondió {{status}}",
        editTitle: "Editar destino",
        newTitle: "Nuevo destino",
        modalSubtitle: "Elija qué avisar y adónde enviarlo.",
        sectionWhen: "Qué avisar",
        sectionWhere: "Adónde enviar",
        sectionSecurity: "Seguridad",
        searchHint: "Escriba para buscar",
        soon: "próximamente",
        noEvent: "Ningún evento con ese nombre",
        weWarnWhen: "Avisamos cuando {{description}}.",
        url: "Dirección",
        urlPlaceholder: "https://su-sistema.com/avisos",
        urlInvalid: "La dirección debe comenzar con http:// o https://",
        urlHelp:
          "Enviamos un POST con el contenido en JSON. Responda 2xx en hasta 10 segundos.",
        description: "Descripción",
        descriptionPlaceholder: "Para qué sirve este destino",
        secret: "Secreto",
        secretUnchanged: "••••••  (sin cambios)",
        secretOptional: "opcional",
        secretExists:
          "Ya existe un secreto. Déjelo en blanco para mantenerlo, o escriba otro para reemplazarlo.",
        secretHelp:
          "Con un secreto, firmamos cada envío en el encabezado X-Markedesk-Signature — así su sistema confirma que el aviso vino de aquí.",
        seeRequest: "Ver la solicitud que enviamos",
        cancel: "Cancelar",
        save: "Guardar cambios",
        create: "Registrar destino",
        saved: "Destino guardado",
        created: "Destino registrado",
        removed: "Destino eliminado",
        removeTitle: "Eliminar destino",
        removeText: "{{url}} deja de recibir los avisos de {{event}}.",
        testFailed: "Su sistema respondió: {{error}}",
        testOk: "Recibido — respondió {{status}} en {{duration}}ms",
        samplePath: "/su-direccion",
        sampleContent: "contenido del evento",
      },
      eventCatalog: {
        groups: {
          atendimento: "Atención",
          mensagem: "Mensaje",
          contato: "Contacto",
          conexao: "Conexión",
          usuario: "Usuario",
          plataforma: "Plataforma",
        },
        ticket_created: {
          label: "Atención abierta",
          description: "llegó una conversación nueva",
        },
        ticket_updated: {
          label: "Atención modificada",
          description: "cambió algún dato de la atención",
        },
        ticket_assigned: {
          label: "Atención aceptada",
          description: "un agente asumió la conversación",
        },
        ticket_transferred: {
          label: "Atención transferida",
          description: "cambió de cola o de agente",
        },
        ticket_closed: {
          label: "Atención finalizada",
          description: "la conversación fue cerrada",
        },
        ticket_reopened: {
          label: "Atención reabierta",
          description: "el contacto volvió a escribir tras el cierre",
        },
        ticket_deleted: {
          label: "Atención eliminada",
          description: "la atención fue borrada",
        },
        ticket_tagged: {
          label: "Etiqueta añadida a la atención",
          description: "marcaron la atención con una etiqueta",
        },
        ticket_untagged: {
          label: "Etiqueta quitada de la atención",
          description: "quitaron una etiqueta de la atención",
        },
        ticket_messageReceived: {
          label: "Mensaje recibido",
          description: "el contacto envió algo",
        },
        ticket_messageSent: {
          label: "Mensaje enviado",
          description: "la plataforma envió algo",
        },
        ticket_messageEdited: {
          label: "Mensaje editado",
          description: "el autor lo cambió después de enviarlo",
        },
        ticket_messageDeleted: {
          label: "Mensaje borrado",
          description: "el mensaje fue quitado de la conversación",
        },
        ticket_messageReacted: {
          label: "Reacción en el mensaje",
          description: "alguien reaccionó con un emoji",
        },
        message_sent: {
          label: "Mensaje enviado (sin atención)",
          description: "envío suelto, fuera de una atención",
        },
        message_edited: {
          label: "Mensaje editado (sin atención)",
          description: "edición de un envío suelto",
        },
        message_deleted: {
          label: "Mensaje borrado (sin atención)",
          description: "borrado de un envío suelto",
        },
        message_reacted: {
          label: "Reacción (sin atención)",
          description: "reacción en un envío suelto",
        },
        message_ackChanged: {
          label: "Confirmación de entrega",
          description: "el mensaje fue entregado o leído",
        },
        message_mediaRetried: {
          label: "Archivo redescargado",
          description: "intentamos bajar el archivo otra vez",
        },
        message_received: {
          label: "Mensaje recibido (sin atención)",
          description: "recepción fuera de una atención",
        },
        contact_created: {
          label: "Contacto creado",
          description: "un contacto nuevo entró en la base",
        },
        contact_updated: {
          label: "Contacto modificado",
          description: "cambió nombre, número u otro dato",
        },
        contact_deleted: {
          label: "Contacto eliminado",
          description: "el contacto fue quitado",
        },
        contact_tagged: {
          label: "Etiqueta añadida al contacto",
          description: "marcaron el contacto con una etiqueta",
        },
        contact_untagged: {
          label: "Etiqueta quitada del contacto",
          description: "quitaron una etiqueta del contacto",
        },
        connection_created: {
          label: "Conexión creada",
          description: "registraron una conexión nueva",
        },
        connection_updated: {
          label: "Conexión modificada",
          description: "cambió la configuración de la conexión",
        },
        connection_deleted: {
          label: "Conexión eliminada",
          description: "la conexión fue quitada",
        },
        connection_statusChanged: {
          label: "Conexión cambió de estado",
          description: "conectó, cayó o pidió leer el código",
        },
        connection_disconnected: {
          label: "Conexión caída",
          description: "la conexión perdió el vínculo",
        },
        connection_qrcodeReceived: {
          label: "Código de lectura generado",
          description: "hay un QR nuevo esperando lectura",
        },
        connection_rateLimited: {
          label: "Conexión limitada",
          description: "el proveedor empezó a rechazar por exceso",
        },
        user_created: {
          label: "Usuario creado",
          description: "un usuario nuevo entró en la empresa",
        },
        user_updated: {
          label: "Usuario modificado",
          description: "cambió dato o permiso del usuario",
        },
        user_deleted: {
          label: "Usuario eliminado",
          description: "el usuario fue quitado",
        },
        company_created: {
          label: "Empresa registrada",
          description: "alguien completó el registro en el sitio",
        },
        company_updated: {
          label: "Empresa modificada",
          description: "cambio dato de registro de la empresa",
        },
      },
      badges: {
        new: "Nuevo",
        beta: "En pruebas",
      },
      plugins: {
        origem: {
          titulo: "Origen",
          todos: "Todos",
          required: "Obligatorios",
          company: "De la empresa",
          builtin: "Del producto",
          obrigatorio: "Obligatorio",
          obrigatorioTooltip:
            "Definido como obligatorio por la plataforma — se reinstala automáticamente si se elimina",
          vazio: "Ningún plugin en esta categoría.",
          porMantenedor: "por {{nome}}",
          usaParceiro: " • usa {{nome}}",
        },
        sobre: {
          acao: "Acerca de y soporte",
          quemMantem: "Mantenido por",
          suporte: "Soporte",
          site: "Sitio web",
          servicoTerceiro: "Servicio de terceros",
          instalacao: "Instalación",
          identificador: "Identificador: {{id}}",
          endereco: "Dirección: {{url}}",
          execucao: "Ejecución: {{modo}}",
          execucaoRemota: "proceso propio (remoto)",
          execucaoLocal: "dentro del backend",
          semFicha:
            "Este plugin no declaró información de mantenimiento y soporte. Ante cualquier problema, contacte a quien lo instaló en esta empresa.",
          fechar: "Cerrar",
          mantenedorTipo: {
            "product-team": "Equipo del producto",
            partner: "Socio",
          },
        },
        compat: {
          ctaRegister: "para poder registrarlo",
          ctaRestore: "para restaurar todas las funcionalidades",
          versionSuffix: " ({{version}})",
          sdkOutdatedMinSuffix: " — este backend requiere plugin-sdk >= {{min}}",
          sdkOutdated: "SDK del plugin desactualizado{{versionSuffix}}{{minSuffix}}. Actualice el plugin-sdk en el servidor remoto {{cta}}.",
          backendOutdated: "Este plugin requiere backend >= {{minBackendVersion}} (este backend está en la {{backendVersion}}). Actualice Markedesk {{cta}}.",
          rangeAnd: "y",
          sdkOutOfRange: "El SDK del plugin ({{sdkVersion}}) está fuera del rango soportado por el propio plugin ({{range}}). Ajuste la versión de plugin-sdk en el servidor remoto {{cta}}.",
        },
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        forgotInstruction: "Ingresa el correo registrado para recibir el enlace de recuperacion de contrasena.",
        resetInstruction: "Define tu nueva contrasena para finalizar la recuperacion del acceso.",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          confirmPassword: "Confirmar contrasena",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          forgotPassword: "Olvide mi contrasena",
          sendRecovery: "Enviar enlace de recuperacion",
          backToLogin: "Volver al login",
          resetPassword: "Restablecer contrasena",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
        toasts: {
          recoveryEmailSent: "Si el correo esta registrado, enviaremos un enlace de recuperacion.",
          passwordResetSuccess: "Contrasena restablecida correctamente. Inicia sesion con la nueva contrasena.",
          passwordMismatch: "Las contrasenas informadas no coinciden.",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        deleteTransfer: {
          title: "Transferir tickets antes de eliminar",
          message: "Esta conexión aún tiene {{count}} ticket(s) abierto(s), pendiente(s) o de grupo. Para eliminarla, transfiéralos a otra conexión.",
          target: "Conexión de destino",
          transfer: "Transferir tickets",
          cancel: "Cancelar",
          noTarget: "No hay otra conexión para recibir los tickets. Cree una conexión o cierre los tickets antes de eliminar.",
          transferred: "{{count}} ticket(s) transferido(s).",
        },
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          restart: "Reiniciar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          otherServer: "No pertenece a este servidor",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          queues: "Colas",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar historial",
          importOldMessagesDescription: "Importa mensajes de las últimas 24h al conectar",
          importOldMessagesDisabled: "Funcionalidad temporalmente deshabilitada para mejoras",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Incluir grupos",
          closedTicketsPostImported: "Cerrar tickets",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Al guardar, su conexión será cerrada y necesitará escanear el QR Code nuevamente. Los mensajes de las últimas 24h se importarán al reconectar.",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationEnd: "Fecha final",
          maxUseCollectiveVacation: "Repeticiones por conversación",
          maxUseCollectiveVacationHelp: "Cuántas veces el aviso se envía en la misma conversación. 0 = sin límite.",
          attachVacationMedia: "Adjuntar imagen/PDF",
          removeVacationMedia: "Quitar adjunto",
          saveFirstToAttach: "Guarde la conexión antes de adjuntar un archivo",
          vacationMediaUploaded: "Adjunto cargado.",
          vacationMediaRemoved: "Adjunto quitado.",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        import: {
          error: "Error de Importación",
          completed: "Importación Completada",
          importing: "Importando Contactos",
          fileName: "Archivo",
          errorMessage: "Error",
          processingFile: "Procesando archivo",
          contacts: "contactos",
          created: "Creados",
          updated: "Actualizados",
          skipped: "Omitidos",
          errors: "Errores",
          fileCompleted: "¡Archivo completamente importado!",
          lastTaskSummary: "Resumen de la Última Tarea",
          totalProcessed: "Total Procesado",
          completedFiles: "Archivos Completados",
          estimatedTime: "Estimación",
        },
        title: "Contactos",
        mergeProgress: "Fusionando {{moved}}/{{total}} mensajes",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
          mergeQueued: "Fusión programada. Le avisaremos cuando termine.",
          mergeDone: "Fusión completada.",
          mergeFailed: "La fusión falló",
          mergeFailedGeneric: "No se pudo completar la fusión.",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      mergeContactModal: {
        title: "Fusionar contacto",
        keeps: "Se queda",
        absorbed: "Será absorbido",
        searchPlaceholder: "Buscar contacto por nombre o número",
        noCandidates: "No se encontró ningún contacto del mismo tipo",
        willMove: "Pasará al contacto que se queda:",
        counts: {
          messages: "mensajes",
          tickets: "tickets",
          schedules: "programaciones",
          contactTags: "etiquetas",
          contactDocuments: "documentos",
          contactCustomFields: "campos personalizados",
          contactWallets: "carteras",
          dialogChatBots: "diálogos de chatbot",
          ticketNotes: "notas",
          campaignShippings: "envíos de campaña",
        },
        warningDelete: "{{name}} será eliminado. No se puede deshacer.",
        warningOpenTickets: "{{name}} tiene {{count}} ticket(s) abierto(s), que seguirán abiertos.",
        cancel: "Cancelar",
        confirm: "Fusionar",
        tooltip: "Fusionar con otro contacto",
        blocked: {
          typeMismatch: "Un grupo y un contacto no se pueden fusionar",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
          numberChecking: "Verificando número...",
          numberValid: "Número válido en WhatsApp",
          numberInvalid: "Número no encontrado en WhatsApp",
          numberInvalidWarning: "No pudimos validar este número en WhatsApp. Si desea continuar de todos modos, tenga en cuenta que enviar mensajes a números que no existen puede resultar en una sanción de WhatsApp.",
          numberInvalidConfirmTitle: "Número no validado",
          existingContactNoOptions: "Ningún contacto encontrado",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          useAnyway: "Usar de todos modos",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          historyQueues: "Ver historial de otras colas",
          historyQueuesHint: "Colas EXTRA cuyo historial el usuario puede ver, sin atenderlas. Las colas que atiende ya muestran el historial automáticamente.",
          connectionAccess: "Conexiones que puede ver",
          connectionAccessHint: "Limita qué conexiones ve este usuario — atenciones e historial. Vale junto con las colas: necesita acceso por la cola Y por la conexión.",
          connectionAccessEmpty: "Ninguna conexión seleccionada: este usuario no verá ninguna atención.",
          viewAllConnections: "Acceso a las conexiones",
          viewAllConnectionsAll: "Todas las conexiones",
          viewAllConnectionsSelected: "Solo las seleccionadas",
          attendanceQueues: "Colas de atención",
          attendanceQueuesHint: "Colas que el usuario atiende. El historial de estas colas ya queda visible automáticamente.",
          whatsappHint: "Conexión predeterminada que el usuario usa para iniciar conversaciones.",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
        },
        tabs: {
          general: "General",
          queues: "Colas y Conexión",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          isInternal: "Comunicación interna (no se envía al contacto)",
          isInternalHelp: "El mensaje entra en el ticket como nota interna, visible solo para el equipo.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      ticket: {
        spyBanner: "Modo espía — sin marcar como leído",
        spyNoMessages: "No se encontraron mensajes",
        spyMediaLocation: "Ubicación",
        spyMediaContact: "Contacto",
        spyMediaAudio: "Audio",
        spyMediaVideo: "Video",
        spyMediaDocument: "Documento",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        noConnections: "Sin conexiones disponibles para usted",
        noConnectionsAdmin: "Ninguna conexión registrada — agregue una conexión a la empresa",
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          auditLogs: "Auditoría",
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          termsOfUse: "Términos de Uso",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          allConnections: "Admin conexiones",
          tasks: "Tareas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
          socketStatus: {
            connected: "Tiempo real conectado",
            connecting: "Conectando al tiempo real…",
            reconnecting: "Reconectando al tiempo real…",
            disconnected: "Tiempo real desconectado",
            slow: "Tiempo real lento — {{ms}} ms de retraso",
            details: {
              title: "Calidad del tiempo real",
              rtt: "Ida y vuelta",
              network: "Tu red",
              server: "Servidor",
              jitter: "Variación",
              loopLag: "Carga del servidor",
              lost: "Pings sin respuesta",
              reconnects: "Reconexiones",
              waiting: "Midiendo…",
              hintServer: "La lentitud está en el servidor.",
              hintNetwork: "La lentitud está en tu conexión.",
            },
          },
        },
      },
      tasks: {
        title: "Tareas",
        searchPlaceholder: "Buscar tareas...",
        noTasks: "No se encontraron tareas. ¡Crea una nueva tarea!",
        buttons: {
          newTask: "Nueva Tarea",
          cancel: "Cancelar",
          save: "Guardar",
          create: "Crear",
        },
        toasts: {
          created: "¡Tarea creada con éxito!",
          updated: "¡Tarea actualizada con éxito!",
          deleted: "¡Tarea eliminada con éxito!",
          completed: "¡Tarea completada!",
          reopened: "¡Tarea reabierta!",
        },
        validation: {
          titleRequired: "El título de la tarea es obligatorio.",
          reminderNeedsTime: "Para usar el recordatorio, defina la hora de inicio de la tarea.",
        },
        stats: {
          total: "Total",
          completed: "Completadas",
          pending: "Pendientes",
          highPriority: "Alta",
          mediumPriority: "Media",
          lowPriority: "Baja",
        },
        filters: {
          status: "Estado",
          priority: "Prioridad",
          orderBy: "Ordenar por",
          user: "Usuario",
          all: "Todos",
          pending: "Pendiente",
          completed: "Completado",
          low: "Baja",
          medium: "Media",
          high: "Alta",
          dueDateAsc: "Vencimiento (más antiguo)",
          dueDateDesc: "Vencimiento (más reciente)",
          priorityAsc: "Prioridad (baja a alta)",
          priorityDesc: "Prioridad (alta a baja)",
          createdAtAsc: "Más antiguo primero",
          createdAtDesc: "Más reciente primero",
        },
        priority: {
          low: "Baja",
          medium: "Media",
          high: "Alta",
        },
        status: {
          pending: "Pendiente",
          completed: "Completado",
        },
        recurrence: {
          none: "Ninguna",
          daily: "Diario",
          weekly: "Semanal",
          monthly: "Mensual",
        },
        reminder: {
          none: "Ninguno",
          minutes: "minutos",
          hour: "hora",
          hours: "horas",
          day: "día",
          message: "Recordatorio de tarea",
          dialogTitle: "Recordatorio de Tarea",
          dialogScheduledFor: "Programada para",
          dialogDismiss: "Entendido",
        },
        card: {
          dueDate: "Vence:",
          schedule: "Horario:",
          recurrence: "Recurrencia:",
          assignedTo: "Asignado a:",
          createdBy: "Creado por:",
          noDescription: "Sin descripción",
          overdue: "Vencida",
          dueToday: "Vence hoy",
        },
        pagination: {
          loadMore: "Cargar más",
          loading: "Cargando...",
          loadPrevious: "Ver días anteriores",
          noDate: "Sin fecha",
          overdueGroup: "Vencidas",
        },
        table: {
          title: "Título",
          priority: "Prioridad",
          dueDate: "Fecha de Vencimiento",
          assignedTo: "Asignado A",
          status: "Estado",
          actions: "Acciones",
        },
        modal: {
          newTitle: "Nueva Tarea",
          editTitle: "Editar Tarea",
          titleField: "Título",
          description: "Descripción",
          priority: "Prioridad",
          dueDate: "Fecha de Vencimiento",
          assignTo: "Asignar A",
          schedule: "Horario",
          startTime: "Hora de Inicio",
          endTime: "Hora de Fin",
          recurrence: "Recurrencia",
          reminder: "Recordatorio",
          notifyBefore: "Notificar antes",
          reminderHelp: "Recibirás una notificación antes de la hora programada de la tarea.",
        },
        calendar: {
          weekDays: {
            sun: "Dom",
            mon: "Lun",
            tue: "Mar",
            wed: "Mié",
            thu: "Jue",
            fri: "Vie",
            sat: "Sáb",
          },
          months: {
            jan: "Enero",
            feb: "Febrero",
            mar: "Marzo",
            apr: "Abril",
            may: "Mayo",
            jun: "Junio",
            jul: "Julio",
            aug: "Agosto",
            sep: "Septiembre",
            oct: "Octubre",
            nov: "Noviembre",
            dec: "Diciembre",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar Tarea",
          deleteMessage: "¿Estás seguro de que quieres eliminar esta tarea? Esta acción no se puede deshacer.",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        transfer: "Ticket Transferido",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message: "Mensaje",
            messageVariation: "Variación",
            addVariation: "Agregar variación",
            removeVariation: "Eliminar variación",
            confirmationMessage: "Mensaje de confirmación",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            channelInternal: "Interno",
            channelPlugin: "Plugin",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            pendingTicketStatus: "Pendiente",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
            expiresAt: "Expira el",
            expiresAtHelp: "Deje en blanco para que el boletín no expire",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      connectionSelect: {
        inputLabel: "Conexiones",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          document: "Documento",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          serverId: "Instancia",
          serverIdHelp: "Deje vacío para definirse en el primer inicio de sesión",
          allServers: "Todas las instancias",
          noServer: "Sin instancia",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          storageGb: "Almacenamiento (GB)",
          queues: "Colas",
          amount: "Valor",
          features: {
            useWhatsapp: "WhatsApp",
            useWhatsappOfficial: "WhatsApp Oficial",
            useFacebook: "Facebook",
            useInstagram: "Instagram",
            useCampaigns: "Campañas",
            useSchedules: "Programaciones",
            useInternalChat: "Chat interno",
            useExternalApi: "API externa",
            useKanban: "Kanban",
            useIntegrations: "Integraciones",
            wavoip: "Wavoip",
          },
          addons: {
            title: "Campos adicionales",
            subtitle: "Ítems cobrados por separado, con valor y unidad propios",
            type: "Tipo",
            description: "Descripción",
            quantity: "Cant.",
            unit: "Unidad",
            unitAmount: "Valor unitario",
            total: "Valor total",
            add: "Agregar ítem",
            remove: "Quitar ítem",
            sum: "Suma de adicionales:",
            types: {
              user: "Usuario",
              connection: "Conexión",
              storage: "Almacenamiento",
            },
          },
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        internalChip: "Interna",
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      auditLogs: {
        newRecords: "{{count}} registro(s) nuevo(s) desde la última actualización.",
        searchPlaceholder: "Buscar por objetivo o persona",
        moreFilters: "Más filtros",
        clearFilters: "Limpiar filtros",
        emptyFiltered: "Ninguna acción coincide con estos filtros.",
        stoppedUntil: "Nada encontrado hasta {{day}}.",
        keepSearching: "Seguir buscando",
        showDetails: "Ver detalles",
        hideDetails: "Ocultar detalles",
        fields: {
          session: {
            name: "Agente",
          },
          ticketTransfer: {
            fromName: "Origen",
            toName: "Destino",
            toConnectionId: "Id del destino",
            ticketCount: "Tickets movidos",
          },
          connection: {
            name: "Nombre",
            channel: "Canal",
            number: "Número",
          },
        },
        entities: {
          auth: "Acceso",
          session: "Sesión",
          connection: "Conexión",
        },
        sentences: {
          auth: {
            logged_in: "{{actor}} inició sesión.",
            logged_out: "{{actor}} cerró sesión.",
          },
          session: {
            started: "{{actor}} inició sesión.",
            ended: "{{actor}} cerró sesión.",
          },
          connection: {
            tickets_transferred: "{{actor}} transfirió {{ticketCount}} ticket(s) de {{fromName}} a {{toName}}.",
            deleted: "{{actor}} eliminó la conexión {{name}}.",
          },
        },
        title: "Auditoría",
        refresh: "Actualizar",
        loadMore: "Cargar más",
        empty: "No se encontraron registros de auditoría.",
        end: "Fin del historial.",
        support: "Soporte",
        filters: {
          person: "Persona",
          action: "Acción",
          status: "Resultado",
          source: "Origen",
          all: "Todos",
          from: "Desde",
          to: "Hasta",
          supportOnly: "Solo acciones del soporte",
        },
        table: {
          time: "Hora",
          actor: "Quién",
          action: "Acción",
          target: "Objetivo",
          status: "Resultado",
        },
        actor: {
          system: "Sistema",
          api: "API ({{token}})",
          unknownUser: "Usuario #{{id}}",
        },
        details: {
          context: "Contexto",
          route: "Ruta",
          ip: "IP",
          userAgent: "Navegador",
          server: "Servidor",
          actorCompany: "Empresa de quien actuó",
          source: "Origen",
          data: "Datos",
        },
        actions: {
          auth: {
            logged_in: "Inició sesión",
            logged_out: "Cerró sesión",
          },
          session: {
            started: "Inició sesión",
            ended: "Cerró sesión",
          },
          connection: {
            tickets_transferred: "Tickets transferidos",
            deleted: "Conexión eliminada",
          },
        },
        statuses: {
          success: "Éxito",
          denied: "Denegado",
          failed: "Falló",
        },
        sources: {
          web: "Panel",
          api: "API",
          plugin: "Plugin",
          job: "Rutina automática",
          system: "Sistema",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            mergeHistoryByContact: "Combinar historial entre conexiones",
            mergeHistoryByContactHelp: "Muestra en el ticket todas las conversaciones del contacto, de todas las conexiones, incluidas las atenciones posteriores",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            autoCapitalizeMessage: "Primera letra del mensaje en mayúscula",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            tasksEnabled: "Habilitar módulo de Tareas",
            testNotification: "Probar Notificación",
            testNotificationSuccess: "¡Notificación enviada! Si no apareció, verifica los permisos de notificación de tu navegador/dispositivo.",
            testNotificationBlocked: "Notificaciones bloqueadas. Permite notificaciones en la configuración de tu navegador/dispositivo.",
            testNotificationUnsupported: "Este navegador no soporta notificaciones.",
            testNotificationTitle: "Prueba de Notificación",
            testNotificationBody: "¡Las notificaciones están funcionando correctamente!",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        resendFailed: "Error en el envío — haga clic para reenviar",
        resendButton: "Reenviar",
        resending: "Reenviando...",
        resent: "Mensaje reenviado.",
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
          },
          loadHistory: "Cargar Mensajes",
          loadingHistory: "Cargando...",
        },
        fileCard: {
          download: "haz clic para descargar",
          fallbackName: "archivo",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        appointmentsModal: {
          title: "Observaciones de la atención",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
        deleteWord: "Eliminar",
        typeToConfirm: "Escriba \"{{text}}\" para confirmar",
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        copy: "Copiar",
        copied: "¡Mensaje copiado!",
        copiedImage: "¡Imagen copiada!",
        download: "Descargar",
        forward: "Enviar",
        toForward: "Enviar",
        react: "Reaccionar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        [WHATSAPP_ERRORS.HAS_OPEN_TICKETS]: "Esta conexión aún tiene tickets abiertos. Transfiéralos a otra conexión antes de eliminar.",
        [AUDIT_ERRORS.INVALID_CURSOR]: "La página de auditoría expiró o no es válida. Actualice la lista.",
        [AUDIT_ERRORS.INVALID_FILTER]: "Filtro de auditoría no válido. Revise los campos e intente de nuevo.",
        ERR_USER_LAST_ADMIN:
          "No se puede cambiar este perfil porque es el único administrador de la empresa. Defina a otro usuario como administrador antes de modificar este registro.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        [AUTH_ERRORS.NO_PERMISSION]: "No tienes permiso para acceder a este recurso.",
        [COMPANY_SETTINGS_ERRORS.INVALID_COLUMN]: "Esta configuración no existe.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        [WHATSAPP_ERRORS.OTHER_SERVER]: "Esta conexión pertenece a otro servidor y no se puede gestionar desde aquí.",
        [MESSAGE_ERRORS.METADATA_INVALID]: "Dato de plugin no válido en el mensaje.",
        [MESSAGE_ERRORS.METADATA_FOREIGN_NAMESPACE]: "Un plugin intentó escribir en el espacio de otro plugin.",
        [MESSAGE_ERRORS.METADATA_TOO_LARGE]: "El dato que el plugin quiso guardar en el mensaje superó el límite.",
        [CONTACT_ERRORS.MERGE_FORBIDDEN]: "Solo los administradores pueden fusionar contactos.",
        [CONTACT_ERRORS.MERGE_SAME]: "Elija un contacto diferente para fusionar.",
        [CONTACT_ERRORS.MERGE_TYPE_MISMATCH]: "Un grupo solo se puede fusionar con un grupo, y un contacto con un contacto.",
        [CONTACT_ERRORS.MERGE_ALREADY_QUEUED]: "Ya hay una fusión en curso para este contacto.",
        [TICKET_ERRORS.REPORT_INVALID_FILTER]: "Filtro del informe inválido. Revise las fechas e inténtelo de nuevo.",
        [TICKET_ERRORS.GROUP_NOT_ALLOWED]: "Esta conexión no permite grupos. Habilite \"Permitir grupos\" en la conexión para abrir una atención de grupo.",
        [TICKET_ERRORS.CONNECTION_NOT_ALLOWED]: "No tiene acceso a la conexión de esta atención.",
        [CAMPAIGN_ERRORS.NOT_FOUND]: "Campaña no encontrada.",
        [SCHEDULE_ERRORS.NOT_FOUND]: "Programación no encontrada.",
        [ANNOUNCEMENT_ERRORS.NOT_FOUND]: "Informativo no encontrado.",
        [MEDIA_ERRORS.INVALID_PATH]: "Archivo no válido para esta operación.",
        [COMPANY_ERRORS.DUPLICATE_NAME]: "Ya existe una empresa registrada con ese nombre.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",

        // Errores de documentos
        ERR_DOCUMENT_ALREADY_EXISTS: "Este documento ya está registrado para otro contacto en la empresa.",
        ERR_INVALID_CPF: "CPF inválido. Por favor, verifique los dígitos ingresados.",
        ERR_INVALID_CNPJ: "CNPJ inválido. Por favor, verifique los dígitos ingresados.",
        ERR_INVALID_DOCUMENT: "Documento inválido. Por favor, verifique el tipo y los dígitos ingresados.",
        ERR_CPF_LENGTH: "El CPF debe tener exactamente 11 dígitos.",
        ERR_CNPJ_LENGTH: "El CNPJ debe tener exactamente 14 dígitos.",
        ERR_OUTRO_LENGTH: "El documento debe tener como máximo {{max}} caracteres.",
      },
      documents: {
        type: "Tipo",
        number: "Número de Documento",
        placeholder: "Ingrese CPF, CNPJ u otro documento",
        addDocument: "+ Agregar Documento",
        cpf: "CPF",
        cnpj: "CNPJ",
        outro: "Otro",
        label: "Etiqueta",
        labelPlaceholder: "Ej: Inscripción Estatal",
        labelRequired: "Indique el nombre del documento",
        labelMaxLength: "La etiqueta debe tener como máximo {{max}} caracteres",
        typeRequired: "El tipo es obligatorio",
        numberRequired: "El número del documento es obligatorio",
        cpfLength: "El CPF debe tener 11 dígitos",
        cpfInvalid: "CPF inválido",
        cnpjLength: "El CNPJ debe tener 14 caracteres",
        cnpjInvalid: "CNPJ inválido",
        outroRequired: "El documento es obligatorio",
        outroMaxLength: "El documento debe tener como máximo {{max}} caracteres",
        fullFormMessage: "Para agregar documentos, use el formulario completo de contactos."
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
      installPWA: {
        title: "Instalar Aplicación",
        message: "Instala la app para una experiencia más rápida y acceso directo desde la pantalla de inicio.",
        installButton: "Instalar",
        dismissButton: "Ahora no",
        iosInstructions: "Para instalar: toca {{shareIcon}} y luego \"Agregar a pantalla de inicio\"",
      },
      crmSettings: {
        title: "Integración CRM",
        description: "Configure el tipo de gestión de facturas y los endpoints del CRM externo",
        invoiceManagementType: "Tipo de Gestión de Factura",
        invoiceManagementNone: "Ninguno",
        urlInvoiceByCnpj: "URL consulta factura por CNPJ",
        urlInvoiceByCnpjHelper: "Endpoint del CRM para consultar facturas por el CNPJ del cliente",
        authorizationByCnpj: "Authorization (Factura por CNPJ)",
        urlInvoiceById: "URL consulta factura por Invoice ID",
        urlInvoiceByIdHelper: "Endpoint del CRM para consultar facturas por el ID de la factura",
        authorizationById: "Authorization (Factura por ID)",
        authorizationHelper: "Token de autorización (ej: Bearer xxxxxxxx)",
        billingCheckTime: "Verificación de Facturas",
        testButton: "Ejecutar Verificación Ahora",
        testRunning: "Verificando...",
        testSuccess: "Verificación de facturas ejecutada con éxito",
        testError: "Error al ejecutar verificación de facturas",
      },
      companyUsage: {
        settings: {
          title: "Recolección de uso por empresa",
          description: "Define cuándo el sistema realizará el snapshot diario de mensajes, archivos, contactos y tickets de cada empresa.",
          cronLabel: "Recolección de uso",
          incrementalLabel: "Modo incremental",
          incrementalHelp: "Cuando está habilitado, solo procesa los mensajes nuevos desde el último snapshot (rápido). Cuando está deshabilitado, realiza un scan completo de la tabla cada vez (lento, pero 100% preciso).",
        },
        page: {
          title: "Consumo",
          tabOwn: "Mi empresa",
          tabAll: "Todas las empresas",
          lastSnapshot: "Último snapshot",
          refreshNow: "Actualizar ahora",
          nextRunIn: "Próxima recolección en",
          refreshSuccess: "Snapshot actualizado",
          recalculate: "Recalcular",
          recalculateSuccess: "Recalculado",
          update: "Actualizar",
          metrics: {
            messages: "Mensajes",
            messagesSize: "Tamaño de los mensajes",
            files: "Archivos",
            filesSize: "Tamaño de los archivos",
            contacts: "Contactos",
            contactsSize: "Tamaño de los contactos",
            tickets: "Tickets",
            ticketsSize: "Tamaño de los tickets",
          },
          chart: {
            title: "Evolución del consumo",
            daily: "Diario",
            weekly: "Semanal",
            monthly: "Mensual",
            empty: "Se necesitan al menos 2 snapshots para generar el gráfico.",
            messages: "Mensajes",
            mbMessages: "MB Mensajes",
            mbFiles: "MB Archivos",
          },
          history: {
            title: "Historial (últimos snapshots)",
            empty: "Aún no hay snapshots",
            colDate: "Fecha",
            colMessages: "Mensajes",
            colMbMessages: "MB Mensajes",
            colFiles: "Archivos",
            colMbFiles: "MB Archivos",
            rowsPerPage: "Filas por página",
          },
          admin: {
            colCompany: "Empresa",
            colSnapshot: "Snapshot",
            colActions: "Acciones",
          },
        },
      },
      termsOfUse: {
        title: "Terminos de Uso",
        agreeLabel: "Acepto los terminos de uso",
        scrollHint: "Lea los terminos hasta el final para habilitar la opcion de aceptacion",
        confirmButton: "Confirmar",
        exitButton: "Salir",
        settingsTitle: "Terminos de Uso",
        uploadDescription: "Suba un archivo .docx con los terminos de uso. Este archivo se mostrara a los nuevos usuarios en su primer acceso al sistema.",
        selectFile: "Seleccionar Archivo",
        uploadButton: "Enviar Terminos",
        uploading: "Enviando...",
        uploadSuccess: "Terminos de uso actualizados con exito!",
        uploadError: "Error al enviar los terminos de uso.",
        invalidFileType: "Solo se permiten archivos en formato .docx!",
        previewButton: "Visualizar",
        previewEmpty: "No se encontraron terminos de uso en el servidor.",
        previewError: "Error al cargar los terminos de uso.",
        closeButton: "Cerrar",
      },
    },
  },
};

export { messages };

